import styled from "styled-components";
import { BaseButton } from "@shared/styles/common.styled";

export const GenrealInfo = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: 2px 2px 4px 1px rgba(0, 76, 127, 0.25);
  background-color: white;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  padding: 20px 10px;
  margin-bottom: 15px;
`;

export const Title = styled.h2`
  color: ${(props) => (props?.color ? props.color : "#00aeea")};
  font-size: 18px;
  font-family: lato;
  text-transform: initial;
  line-height: 1;
  margin-top: 0px;
  font-weight: bold !important;
  justify-self: auto;
  margin-bottom: ${(props) => (props?.bottom ? props.bottom : "10px")};
`;

export const TitleOuter = styled.div`
  color: ${(props) => props.color ?? "#00aeea"};
  font-size: 16px;
  font-family: lato;
  text-transform: initial;
  line-height: 1;
  margin-top: 0px;
  font-weight: bold !important;
  justify-self: auto;
  margin-bottom: ${(props) => (props?.bottom ? props.bottom : "10px")};
`;

export const DuplicateLines = styled.span`
  cursor: pointer;
  text-decoration-line: underline !important;
  font-weight: 700;
  color: ${(props) => (props?.color ? props.color : "#474747")};
  &:hover {
    color: ${(props) => (props?.color ? props.color : "#474747")};
  }
`;

export const ButtonData = styled(BaseButton)`
  background: ${(props) => (props?.color ? props.color : "#cccccc")};
  border: ${(props) =>
    props?.color ? "1px solid" + props.color : "1px solid #15aee5"};
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  font-weight: normal;
  width: auto;
  padding: 5px 10px;
  font-size: 16px;
  font-family: lato;
  margin-right: 1px;
  margin-bottom: 0px;
`;

export const FlexRow = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  > div {
    margin-right: 5px;
    margin-bottom: -7px;
  }
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => (props.column ? props.column : "1fr")};
  gap: ${(props) => (props?.gap ? props.gap : "1rem")};
  font-size: 14px;
  color: #ffffff;
  line-height: 1rem;
  border-right: ${(props) => props.borderRight ?? "0px solid #767676"};
  border-left: ${(props) => props.borderLeft ?? "0px solid #767676"};
  border-bottom: ${(props) => props.borderBottom ?? "0px solid #767676"};
  border-bottom-right-radius: ${(props) => props.borderRadius ?? "0px"};
  border-bottom-left-radius: ${(props) => props.borderRadius ?? "0px"};
  margin-bottom: ${(props) => props.marginBottom ?? "0px"};
`;

export const GenrealInfoOrder = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: 2px 2px 4px 1px rgba(0, 76, 127, 0.25);
  background-color: white;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  padding: ${(props) => props.padding ?? "20px 10px"};
  margin-bottom: 15px;
  border: 2px solid #767676;
  border-top-left-radius: 0px;
`;

export const SectionContainer = styled.section`
  width: 100%;
`;

export const OrderHeaderWrapper = styled.div`
  background-color: #767676;
  display: flex;
  justify-content: space-between;
  padding: 10px;
  border-radius: 5px 5px 0px 0px;
`;

export const LinesHeaderWrapper = styled.div`
  background-color: #767676;
  border-radius: 5px 5px 0px 0px;
  margin-top: 10px;
`;

export const GridSubItem = styled.div`
  color: ${(props) => props.color ?? "#0a4986"};
  font-style: ${(props) => props.fontStyle ?? "normal"};
  font-weight: ${(props) => props.fontWeight ?? "400"};
  font-size: ${(props) => props.fontSize ?? "14px"};
  text-align: ${(props) => props.textAlign ?? "left"};
  border-right: ${(props) => props.borderRight ?? "0px solid #767676"};
  border-left: ${(props) => props.borderLeft ?? "0px solid #767676"};
  border-bottom: ${(props) => props.borderBottom ?? "0px solid #767676"};
  padding: ${(props) => props.padding ?? "5px"};
  align-content: ${(props) => props.alignContent ?? "center"};
`;

export const GridItem = styled.div`
  border-right: ${(props) => props.borderRight ?? "2px solid #767676"};
  border-left: ${(props) => props.borderLeft ?? "0px solid #767676"};
  text-align: ${(props) => props.textAlign ?? "center"};
  color: #fff;
  font-weight: ${(props) => props.fontWeight ?? "400"};
  padding: ${(props) => props.padding ?? "11px"};
  font-size: ${(props) => props.fontSize ?? "16px"};
  border-radius: ${(props) => props.radius ?? "0px 0px 0px 0px"};
  align-content: ${(props) => props.alignContent ?? "flex-start"};
`;

export const DivToolTip = {
  maxWidth: "300px",
  wordBreak: "break-all",
  overflowWrap: "break-word",
  display: "block",
  zIndex: 99999,
  backgroundColor: "#fff",
  color: "rgb(71, 71, 71)",
};

export const FlexRowDuplicate = styled.div`
  display: flex;
  width: 100%;
  justify-content: end;
`;
